import React from 'react'
import { get } from 'lodash'
import axios from 'axios'
import store from '~/redux/user/store'
import { getToken } from '~/redux/user/tokens'
import {updateTransaction} from '~/redux/user/helpers.js'
import Cookies from 'js-cookie'
import './style.scss'

class PaygateForm extends React.Component {
  constructor(p) {
    super(p)
    this.state = {
      loading: false,
      name: null
    }
  }
  getVal(key){
    return get(this.props.metadataMap, key)
  }

  onNameChange = (e) => {
    this.setState({
      name: e.target.value
    })
  }

  render() {
    return <div className="paygate-container">
      <input type="text" placeholder={this.getVal('pgFullName') || "Full Name as on Card"} onChange={(e) => this.onNameChange(e)}/>
      <button className='paygate-button cta' onClick={this.processPayment}>{this.state.loading ? `${this.getVal('paymentProcessing')}...` : (this.getVal('payByPaygate') || 'Pay using Paygate')}</button>
      { this.state.error && <div className="error">
          {this.state.error}
        </div> }
      </div>
  }

  getNavigatorLanguage = () => {
    if (navigator.languages && navigator.languages.length) {
      return navigator.languages[0];
    } else {
      return navigator.userLanguage || navigator.language || navigator.browserLanguage || 'en';
    }
  }

  processPayment = () => {
    let errorMsg = this.getVal('pgFullNameError') || "Both first and last name are mandatory";
    if(this.state.name == null || (this.state.name && this.state.name.trim().indexOf(' ') === -1)) {
      this.alert(errorMsg);
      return;
    }
    this.setState({
      loading: true
    })
    var plan = this.props.plan
    var user = store.getState().user
    var redirect_url = '';
    if(this.props.initiateType == 'subscription') {
      redirect_url = window.location.origin + '?popup=notice';
    } else {
      redirect_url = window.location.href;
      Cookies.set('payment_redirect_url', window.location.href)
    }

    var data = {
      email: user.email,
      locale: this.getNavigatorLanguage(),
      site: window.settings.internalName,
      redirect: redirect_url,
      nameOnCard: this.state.name,
      appliedOffers: this.props.offerCode ? [this.props.offerCode] : []
    }

    if(this.props.initiateType === 'transaction') {
      data.contentRequest = {
        contentType: this.props.contentType, //'VIDEO', 'SEASON', 'BUNDLE', 'EPISODE', 'SERIES'
        contentId: plan.contentID || plan.videoID,
        purchaseType: plan.option && plan.option.toUpperCase(), //'RENT', 'PURCHASE'
        videoQuality: plan.key, //'HD', 'SD', 'UHD'
        seriesId: plan.seriesId,
        seasonId: plan.seasonId
      }
    } else {
      data.planId = plan.id
    }

    return (
      getToken()
        .then(token =>  axios({
          url: window.settings.apiBaseUrl + '/payments/paygate/' + this.props.initiateType,
          method: 'POST',
          params: { 'site': window.settings.internalName },
          headers: {
            'Authorization': token,
            'x-api-key': window.settings.baseAPIKey
          },
          data: data
        }))
        .then( d => {
          updateTransaction({
              metadataMap: this.props.metadataMap,
              plan: this.props.plan,
              content: this.props.content
          });
          this.submitForm('https://secure.paygate.co.za/payweb3/process.trans', d.data)
        },(err)=> {
          this.alert(err && err.response && err.response.data && err.response.data.error);
          this.setState({
            loading: false
          })
        })
    )
  }

  alert(msg) {
    this.setState({ error: msg })
    setTimeout(_ => this.setState({ error: null }), 2000)
  }

  submitForm(url, data) {
    var form = document.createElement('form')
    form.setAttribute('method', 'post')
    form.setAttribute('action', url)

    for(var key in data) {
      if(data.hasOwnProperty(key)) {
        var hiddenField = document.createElement('input');
        hiddenField.setAttribute('type', 'hidden');
        hiddenField.setAttribute('name', key);
        hiddenField.setAttribute('value', data[key]);
        form.appendChild(hiddenField);
       }
    }

    document.body.appendChild(form);
    form.submit();
  }
}
export default PaygateForm